/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_SyncingInputs */



/**
* | output |
* | --- |
* | "Syncing" |
*
* @param {Status_SyncingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const status_syncing = /** @type {((inputs?: Status_SyncingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_SyncingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronizando")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sincronizando")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione")
	return /** @type {LocalizedString} */ ("Syncing")
});